"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.S3ItemReference = void 0;
/**
 * @deprecated use S3ItemReference from common instead
 */
var common_1 = require("../common");
Object.defineProperty(exports, "S3ItemReference", { enumerable: true, get: function () { return common_1.S3ItemReference; } });
//# sourceMappingURL=s3-item-reference.js.map